const UUID = /[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}/gi;

/** Telemetry masks ids inside a reason, so its fixed diagnostic fields name the entity and the absent inputs. */
export function missingInputDetail(entityId: string, reason: string): { carrier: string; missing?: string } {
    const missing = [...new Set(reason.match(UUID) ?? [])].slice(0, 6).join(',');
    return { carrier: entityId, ...(missing ? { missing } : {}) };
}
